<script setup lang="ts">
import type { HTMLAttributes } from "vue"
import { cn } from "@/lib/utils"

const props = defineProps<{
  class?: HTMLAttributes["class"]
}>()
</script>

<template>
  <div
    data-slot="card-header"
    :class="cn('@container/card-header border-b border-new-neutral-200 grid auto-rows-min grid-rows-[auto_auto] items-start px-3.5 has-data-[slot=card-action]:grid-cols-[1fr_auto] py-4', props.class)"
  >
    <slot />
  </div>
</template>
